var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyP(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Copy Paste",
    clipPath: "url(#clip0_22_8924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "copy-paste--clipboard-copy-cut-paste"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.25 8.75V6.25C21.25 5.58696 20.9866 4.95107 20.5178 4.48223C20.0489 4.01339 19.413 3.75 18.75 3.75H16.25",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 26.25H3.75C3.08696 26.25 2.45107 25.9866 1.98223 25.5178C1.51339 25.0489 1.25 24.413 1.25 23.75V6.25C1.25 5.58696 1.51339 4.95107 1.98223 4.48223C2.45107 4.01339 3.08696 3.75 3.75 3.75H6.25",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M31.25 13.75H18.75C18.087 13.75 17.4511 14.0134 16.9822 14.4822C16.5134 14.9511 16.25 15.587 16.25 16.25V31.25C16.25 31.913 16.5134 32.5489 16.9822 33.0178C17.4511 33.4866 18.087 33.75 18.75 33.75H31.25C31.913 33.75 32.5489 33.4866 33.0178 33.0178C33.4866 32.5489 33.75 31.913 33.75 31.25V16.25C33.75 15.587 33.4866 14.9511 33.0178 14.4822C32.5489 14.0134 31.913 13.75 31.25 13.75Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.875 1.25H5.625L6.65 5.3C6.71244 5.57107 6.86528 5.81281 7.08338 5.98547C7.30147 6.15813 7.57184 6.25142 7.85 6.25H14.65C14.9282 6.25142 15.1985 6.15813 15.4166 5.98547C15.6347 5.81281 15.7876 5.57107 15.85 5.3L16.875 1.25Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.25 21.25H28.75",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.25 26.25H28.75",
    stroke: "#9B9B9B",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_8924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyP);
export default __webpack_public_path__ + "static/media/CopyP.9f00370af0520bf9b1335ce2943e0eba.svg";
export { ForwardRef as ReactComponent };